import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/abdullatieffathoni/Code/javascript/tds-web/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ImageCard = makeShortcode("ImageCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p><inlineCode parentName="p">{`Menu`}</inlineCode>{` merupakan bagian dari navigasi, sebuah komponen yang berisikan pilihan yang bertujuan untuk membantu user menemukan informasi atau mengeksekusikan sebuah fungsi.`}</p>
    </PageDescription>
    <h2>{`Example`}</h2>
    <Row className="image-card-group" mdxType="Row">
      <Column colMd={12} colLg={12} noGutterSm mdxType="Column">
    <ImageCard titleColor="dark" aspectRatio="16:9" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAs0lEQVQoz82Suw6CQBBF92+1ETbxgUawEGIHFKD/QGGBpSZ8ioYgxkJixSxW113FWBljoLA4ucVMTnIzw7L8jDZhrQvT7IRDepTkjVEudimuoOqGsqQHRAJC/EZJhEqmcrF1vAPvOxg6Sxh2CG750KYuNNN95ifquW55GM0DdMceok2ihFvwgS2FISaLFfjMR2/6RVaj9nRTCu0AHcNFFCfvytS0ciVQqMptHWX/Osrf/+EdTwG4234XOlUAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Square",
              "title": "Square",
              "src": "/static/9bcb90e31d3f5f10f9e1b1e1561367a3/3cbba/app-bar-horizontal2.png",
              "srcSet": ["/static/9bcb90e31d3f5f10f9e1b1e1561367a3/7fc1e/app-bar-horizontal2.png 288w", "/static/9bcb90e31d3f5f10f9e1b1e1561367a3/a5df1/app-bar-horizontal2.png 576w", "/static/9bcb90e31d3f5f10f9e1b1e1561367a3/3cbba/app-bar-horizontal2.png 1152w", "/static/9bcb90e31d3f5f10f9e1b1e1561367a3/b5ff4/app-bar-horizontal2.png 1281w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ImageCard>
      </Column>
    </Row>
    <Row className="image-card-group" mdxType="Row">
      <Column colMd={12} colLg={4} noGutterSm mdxType="Column">
    <ImageCard titleColor="dark" aspectRatio="1:2" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "421px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "199.65277777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAoCAYAAAD+MdrbAAAACXBIWXMAAAsSAAALEgHS3X78AAABu0lEQVRIx+2Xy0sCURjFh8KoqAhaFEmQqdWmILDoSQ8rjKBWCdGqx6pVbWrRMuhF9MIoF0Vk2kNcVCIlQUFQq/4G05rRTB2d0W2nGcGYTUEzs5zF4cJ9/PjOvRfuucQbGSKp0Ce49osTMgq8B39a/xuVlrBPOFco4jdgZiEZ/EAkSqdFhcJ/wv4E8hWFIzHc3j9jeHweprFZXFzeIRqj8Rqg/g98DZBg4gnsXHjQX1SNIZUaCxYbUmwSPj8pDkjTcRy6vOhtaIShqg4r1jOwDCseGKMTcLhukKMzglC3Yct6ioRUoJ0DFmq7kV3eig0OyMgBLND2IEsBKkAFqAAVoAKUA6jrQbaaBzrkAeZpukCUNWNT6jMajzM4cFzBYJpA08AklraPwCZTUpJDAjanB6X1gyiu6cP6nh2MlCiSsVykN0JV0S59D2kuLB2du6FvNUPXMoK1XZs8FeZXdoAoNaQPRUKFVBp44nRD3TmDkrYZbO7b5bB8jdzaURAaM1Ytx2DFWuYT7Ec4ioenF0zPLWNqdhFu7yM+uVTLj4nO2EFujL/M/GGEwhH4xWZsYeL3cfZ5m5nKRP8CxOgbswu4VuFjFUsAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Square",
              "title": "Square",
              "src": "/static/e96c251bcce210ed8bc3631ba94bfbb3/0f7f7/app-bar-vertical.png",
              "srcSet": ["/static/e96c251bcce210ed8bc3631ba94bfbb3/7fc1e/app-bar-vertical.png 288w", "/static/e96c251bcce210ed8bc3631ba94bfbb3/0f7f7/app-bar-vertical.png 421w"],
              "sizes": "(max-width: 421px) 100vw, 421px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ImageCard>
      </Column>
      <Column colMd={12} colLg={4} noGutterSm mdxType="Column">
    <ImageCard titleColor="dark" aspectRatio="1:2" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "421px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "199.65277777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAoCAYAAAD+MdrbAAAACXBIWXMAAAsSAAALEgHS3X78AAAC3ElEQVRIx62Xy09TURDGLw8jIKXQKFUaoigWCq0iRIktRQX7RFvelRoaLUUMBhVJKhJsQMGFaOLCBYnGlbpy4X/ES0p7H7QU136ecwmBoCb2nruYtIuTX76Zb86cudzaemI9nhBAfn+RwOqPDTno/5W1DRLxP+Lguf3BHQTuBj2cSIoQpRQEcVMOUZSQ5MW/gv4JpIepCl6Q8HbxC1y3x9EbmULn/Vm4wjN4tvAJG0nh/xXSQ8urcaRSafSOxhDJP44aXR2OXhlD/8RX2IMz4HkeK9kAqUJRSmMkOg9fvQnVJjv0thGYOmbgjcyRtIXsgMsEKG2mMDzxCpzBhhKTG4V1PnAVbXDfnSZASTYsa2CEAPMrrCitcaDsQh9OWEME+Fw2RjEw12CFlgB1TQGcbhuGixlIFJbVulBcfxO5Ve1w35lCUpDkOisC5hGFJUYHyhs7Ye8agTv0lA0oKzS5UERNMVxlN4UqlE1p7EeD/zE8QzH2GpbWOlFyvgeahj4VXJZNceKIpQvcKY+KQPMOkLYNzwLM29eH57yj8BFTEnTisCrUkBoW1HXiBnVZkNhTpqboLgbhDsfYr95u25whV09dU0661HbZrQ6QNra2oRfaxgA7cGc4XIf+UhD2gUnSh9Mq3pQqj4oKm4NoDaqokPZhoaVH5eGgVsp702anbZiGA6dvhpbUkN4Uo4M8AWGFCjfJ5hAam4Xz1iMYbQEyGPwoMHezpJxGeHwOx8welJu9sin6y4PsNTxU2QIdeaSYU6bAoSfzqGkJoNraj8MmP7hKJ4spaUQIkCtvQqmxHcWWbnDVHcpTpovmvehr6K9Nw2AbhsbiR47RBy/LMzr48CVyzoZQVNtDetBBWqgNrQNReRnNCkgP04fo4+fviIy/wNjUAh7E3mNo8h3efPiGeIJXtmPTvTqz/RNbmW1sbWWQyWQgkVJkvWPvfQXEsbSyjqXVvaDrsqKvAKXxGz0c+g4/zIXOAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Square",
              "title": "Square",
              "src": "/static/6d93bac21845fc5601093ba6cdc973b2/0f7f7/app-sidebar-collapse.png",
              "srcSet": ["/static/6d93bac21845fc5601093ba6cdc973b2/7fc1e/app-sidebar-collapse.png 288w", "/static/6d93bac21845fc5601093ba6cdc973b2/0f7f7/app-sidebar-collapse.png 421w"],
              "sizes": "(max-width: 421px) 100vw, 421px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ImageCard>
      </Column>
    </Row>
    <Row className="image-card-group" mdxType="Row">
      <Column colMd={12} colLg={4} noGutterSm mdxType="Column">
    <ImageCard titleColor="dark" aspectRatio="1:2" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "421px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "199.65277777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAoCAYAAAD+MdrbAAAACXBIWXMAAAsSAAALEgHS3X78AAAE6UlEQVRIx62XV1MbVxiGF9PUwDRjuqhqFJcAAQMqCNSooklAnFCC6aY6OGNjbGpmYk8ymeQqN7lwrvOTMDgYTLPAP+DNdw6sEI5BSyYX7xzNnt2H9yunILzd2gHT5t/bfNx4u016x/UmiNg74rfi94IIFCd2dvexv39AOsT+wSEOAsSe7Z2Kzb2nd0WQKD+Q/UX20uIvr1Hbs4Dm4SW4+p/B2ffMPzY+eIGmwUW4ac7eO4+Z1d+x834PG59zuL75Dkc+H5qGfkDb9GvcuPcQSeVdyK7+FtmWE13TNEBQ2yHkuCAkmlHcPIG9vQMe+r+AbwjoI2Dn5EtoHPNIqhgiSB/09mHkWgegrR1E7F0PlIWtiL7dDiG3Hubux9i9CLi+uYWjoyO0j61AuGmGLL+ZfyTk1CEkrx6h2kZE5rshL2iBsqgVQrYTxs7vggPbRldwo7QbyeX3kVrxNVdCaRcHMckIeiVgKwHTq3pJPVCb+pBl6adc3idQix+qLGqDkOWSAjxG++gyJd6C6IJ6KPUuRGrsiMizQa51+KUyuBCSWQ2jZyYY8CNaBhdQUkfFMHtRUN2FxFtOyHJMUOSaueQ5ZlzX1yBGVw2zZ0piUZJMkOsbEJrrQITWxX8HSpnfCCHDiirvbPCQW0aWobENweAcQVH9ODIoj7KCs/zJxBxm10msMjmMNLhx/U4Hom6184rKC9y8uvJT8SpnSaiyz3eEjvE1/nFq5Te8unHF3hOY6PIqbSMCQ7UN1Itd3KWKwovQN/l7UOZvbIltw3LI1q/a1Mt7MMPYy+GRhuZzDsOzHBKAPlblVb7MYr/w8pBFp+KyE4FhkoCnS48Vg8ESSjoRT1LQhiDm8cohs6XHCqKmUPNqBpBD4bPdRfaJwysVRch0cAgDKE4VWGnJDjnw4RoPMZMaOoXtNuQ25u5ZDmUBfVjlldTYqxwYX9xJII/f6TmHNM92b2PnnLS2KW2dhtY2SDl8wMV68VMgW02mrjkJbTO+ys8N9mG4rok3tSwgXH/IlGcJIZPD4WWUtc3wM8TgHKYNYgw3y7oRITY2KxI5ZAru8DSHYeQsinKnKGzhTa3096H7v7UNa960yh5y9hV3JgvYus62L6ltw3KY7aAjsx2qQjcidLSp0gkoNzT5paTngtpGOXwkYaUMPUd6qRvqslZojB4k3q6jI4C2/7xqyHNJNCo1VshyLTAFPwKO0TbyAgpNDRKK6hBf5IJKW0tACwGtfrFn19RVp8DDi4B0c/jgg3f6J4TcGcBN6wzS7I+gdj1Gcu0sYowTiDNNciVYphBeOgxLzyJ2d/f4je0C4AcODCsdRbJ9DnnN89C1LCCFfseYphBnmSFNI8E6i8iyMVh6ly4DnoTcMboEIaUC0QYHl0pvPxl1Np4KhaYWUfRMSKukc/nSkEXgIt1tSpBQ6ITW5IWmygMdjbH5tpPiUDFUVBQhpQzGjsnLgT4CesbIYdo9OsxtvLKsogyg0tb4xeZC0itg9k4HcXj8EQ39TyEo8rmbrPJWAli5YyG5jPTliVLLIUQXobhhiN9mPwtkD1lP/frHX+ibWcHYk1eYWPgZY09fYfj7H89p9MlL9M+uYu23P7G9s3f5HZtdi4/JKcunz3fMR+b8nOgOxN45PPRdfMcWJ9hde31ji6fgUtE77NZ76X8B/4f+AZb3Rz7gzR+SAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Square",
              "title": "Square",
              "src": "/static/fce625bea121cabbc134c31ca522a7e7/0f7f7/sidebar.png",
              "srcSet": ["/static/fce625bea121cabbc134c31ca522a7e7/7fc1e/sidebar.png 288w", "/static/fce625bea121cabbc134c31ca522a7e7/0f7f7/sidebar.png 421w"],
              "sizes": "(max-width: 421px) 100vw, 421px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ImageCard>
      </Column>
      <Column colMd={12} colLg={4} noGutterSm mdxType="Column">
    <ImageCard titleColor="dark" aspectRatio="1:2" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "421px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "199.65277777777777%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAoCAYAAAD+MdrbAAAACXBIWXMAAAsSAAALEgHS3X78AAAFnklEQVRIx61XWVeTVxRNbTFkJASsoAwGCCEhjCqDMiQgSYAECKAiVkDRAupCa6W2WtouaV/qsq7Vp/4f5aW0y4o4VOtyAgQEK7HP7O57M8igDF192Jz7fcm3c87Z+57vong2/gLPJ6Yg4tPnkxJPQjG8Xgt8dmF8clrEgCJMJuLL2VeYnfsbsyLOzvF6jtevMCfuLYryeyGI9fjklCQkR0AhyCZezOD+w8foOjsEX+cAmo9fQkPPEJp6v4f3+LfwHB1EXTfjsUH4TnyHxt7LaOy5zO9chr9vCDfHHixMz8yxImbIP5iaeomRu3+hIMuJLzVJUMQXwd3zC4rbriLK2oTsupNILu9ClqsXmpwWKFJcUJhqoUj1QJFej+u/ji6IytiiMOEMfr/zCM4qH1pyc6G2uJDtG4SpegAfF7cjz3saac5u2Dx92FpyGOqcZmjzWiV5TMEBDP82tiBKjxC+YIa37z6EqbQVijQnYqx1UJjrsSmzHh9aGnivDh+Yvbz2YbOtCSp7s0R0th/a3FYS3l6YXU44SsL0khboTJXQZLqRsKcDKRVHmeFhbN/bgW17jjCzlgjROglZRpoDarMLKZXHYK7pQSKJdzi6JVQkjA5lp7K3QGnzQ7MWoZoZ6rI80Ni80NrqoGH5KosHURkuGSPgd7TWWuhzGjA8MvZ+Qi0zVKZVI9fdhWJvNzL2trK3LC+9EuoMRwQqIjHfg/g8L26MMMO5VTLU85c/oiBRmYzmIFRW31LYKJClHhp7k1R51R6q2EOT8wR2N5+Dhd6z1Z6kIK0UIaRuqIciCvsMj6wmCjPUskeGwjbE7jzIplN5PqSiolLdMNatckgUw842JJR+QiMHIcwctovKvgHCoMq1LGU/4na1yZ0gIAz91n/B0pXZ67BN2IdpVSeQWfMpkso6kUpPCnO/NbVf9k+X3QQDW3JjXSWzh7r8/djCnSJ2S9yuQysItSSMWZOQGYqtF7e7nVl1Upg2xBe1Q09ysTP+c8lJHFcWbr3kUNxCUuWiwbAhUYSxhc/EQ0LdxfGt0hu0TbBkMWU6ZJYiw8VTRpbMjIVP1yB00NhuGCnCllDvDIUH5Ohanp0gE5ZadS+L4bDZVI38hn6U7j8vM8zm1ovffWhJD4UggsxI0W4sfwW8q4fiAWHmKGujRJgsOrwFuRafi9fAqiVr0x2IkhmekRmmVHShgNnucBxb0T+x1+OY+fXVMgwPB31oywkC0Uft8gGxUZWFKImlR7CN5haCKMMkkfEVNPja44uiyOEgxlZuM/R5LdicJQZqIzNrDEa5boKSg1aT43/3gBWv0bRiZpJSzp1SgySurY52pBT7kVpCY5urOPadHL5Vch2d7oTB5kJcnu8dtpl+iZu376PQ1Qn/0Qt8cB+MuV5szffCkO1BDKEkgdpcHYGK0Fr2IcZeT8KxlT68decBLGUHkVLYQNvUQV92CjHlZ7DdPYDk2i+ICzBWnkUsIaLRcRaGys8QW9bHHr5H5QyeHPQsR2+rR2zFGcQ5P0ea7xKymr+FiVEQGHnP6DwXwnkYy09heIVtWPIfY3/C7jyMorpu6LPEu9cNdeY+kov3rxs6q0euxT11Zg3PPzWybB1//P2iFPmhTC6FnmQqPqjiu9hcfkDC6jiEbTt9FEO8l0U/nfJzLX9oJSEzHB27B7unH6m1QxSEG58Z6Nj0oAhVHLpChKAQArosxswqKcrK0xcJb5EwqaSDJj6OTTtqoEgshSKhmFk1IqHAy+viZSiBYmsRz4oV3HqLbBM8wU7jwaOnuDD0M3oHfsDpS1fRd5H46kf0D/6E/m+ucX1lCU5evCI/P/X1NYzee7QwNTO79Iw9zvj6dQDzgX8wP/8miMAbvJ4PSIj1EsyHYwATk9NLz9hh0ifPJvD4KfFsY1jxX8D/gEiG/wK3Qn4jjci46AAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Square",
              "title": "Square",
              "src": "/static/6b721dc7e3af8811f40deb5e431bd38c/0f7f7/app-sidebar.png",
              "srcSet": ["/static/6b721dc7e3af8811f40deb5e431bd38c/7fc1e/app-sidebar.png 288w", "/static/6b721dc7e3af8811f40deb5e431bd38c/0f7f7/app-sidebar.png 421w"],
              "sizes": "(max-width: 421px) 100vw, 421px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ImageCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      